export default "__VITE_ASSET__DRs0_9iN__"